import { useStore } from 'vuex';
import { computed } from 'vue';
import { urls } from '@/assets/js/urls';

/**
 * This composable provides configuration for the dynamic form.
 * It safely retrieves store-dependent values like auth_code,
 * so components that import this don't need to access Vuex directly.
 */
export function useDynamicFormConfig() {
  const store = useStore();

  const uploadUrl = urls.upload; // 🔹 update your upload endpoint
  const auth_code = computed(() => store.state.Login.login.auth_code);

  return {
    uploadUrl,
    auth_code,
  };
}